export default "es\no\ndónde\nqué\ncómo\ncuántos\ncuánto\ndebería\npoder"